module.exports = __webpack_public_path__ + "static/screenshot-2-b98f0cb1a2bc0f1e3ab2a31b71362a45.png";